import {
  Attachment,
  AttachmentCreateParams,
  AttachmentType,
  FileAccess,
  FileObject,
  FilePurpose,
} from '@citruscamps/citrus-client'
import React from 'react'
import { getAttachmentFileId, hasOnlyCreatedAttachments } from '../../hooks/useFetchAttachments'
import { Dropzone, DropzoneProps } from '../Dropzone/Dropzone'

interface IProps extends Omit<DropzoneProps, 'context' | 'onChange'> {
  values?: Array<Attachment | AttachmentCreateParams>
  parentId: string
  programId: string
  purpose: FilePurpose
  attachmentType: AttachmentType
  access?: FileAccess
  onChange?: (values: Array<Attachment | AttachmentCreateParams>) => void | Promise<void>
}

export const AttachmentDropzone = ({
  values,
  parentId,
  programId,
  purpose,
  access = 'public',
  attachmentType,
  onChange: handleChange,
  children,
  ...props
}: React.PropsWithChildren<IProps>) => {
  const files: string[] | FileObject[] | undefined = hasOnlyCreatedAttachments(values)
    ? values.map((a) => a.file)
    : values?.map((a) => getAttachmentFileId(a))
  return (
    <Dropzone
      {...props}
      context={programId}
      purpose={purpose}
      files={files}
      onChange={async (droppedFiles) => {
        const existingAttachments = droppedFiles
          .map((file): Attachment | AttachmentCreateParams | undefined => {
            const existingAttachment = values?.find(
              (a) => 'id' in file && getAttachmentFileId(a) === file?.id,
            )
            if (existingAttachment) return existingAttachment
            if ('id' in file && file.id) {
              return {
                type: attachmentType,
                program_id: programId,
                file_id: file.id,
                parent_id: parentId,
              }
            }
            return undefined
          })
          .filter((a): a is Attachment | AttachmentCreateParams => Boolean(a))
        await handleChange?.(existingAttachments)
      }}
    >
      {children}
    </Dropzone>
  )
}
